import type { MoneyTotal, Movement, MovementKind, PeriodMoney, TaxLine } from '../model/period';
import { entriesOf, type MovementEntry } from './deductions';

export const DEFINITIVE_MODALITY_NOTE =
	'Estás en pago definitivo de plataformas: lo que te retienen es tu pago y los gastos no se acreditan.';

const cents = (value: number) => Math.round(value * 100) / 100;

const totalOf = (entries: MovementEntry[], kind: MovementKind): MoneyTotal => {
	const group = entries.filter((entry) => entry.kind === kind);
	return {
		amount: cents(group.reduce((sum, entry) => sum + entry.amount, 0)),
		count: group.length,
	};
};

export const buildPeriodMoney = (movements: Movement[], taxLines: TaxLine[], modalityNote?: string): PeriodMoney => {
	const entries = movements.filter((movement) => !movement.notCounted).flatMap(entriesOf);
	return {
		totals: {
			ingreso: totalOf(entries, 'ingreso'),
			deducible: totalOf(entries, 'deducible'),
			no_deducible: totalOf(entries, 'no_deducible'),
		},
		taxLines,
		movements,
		modalityNote,
	};
};
